@if (isUserAuthenticated) {
<mat-nav-list>
    <!-- <a mat-list-item routerLink="/home" (click)="onSidenavClose()">
        <mat-icon>home</mat-icon> <span class="nav-caption">Home</span>
    </a> -->

    @if (hasPrivilege('PRIV_PORTAL_HOME_PAGE')) {
    <a mat-list-item routerLink="/home" (click)="onSidenavClose()">
         <!-- hasPortalRole || hasReadOnlyRole -->
        <mat-icon>home</mat-icon> <span class="nav-caption">Home</span>
    </a>
    }

    <!-- <a mat-list-item routerLink="/homeBiller" (click)="onSidenavClose()" *ngIf="hasBillerRole&&!hasBillerRole">
        <mat-icon>home</mat-icon> <span class="nav-caption">Home</span>
    </a> -->

    @if (hasAnyPrivilege(['PRIV_VP_JOB_MONITOR_VIEW','PRIV_CM_HISTORY_VIEW','PRIV_VP_TEST_SUITE_VIEW'])) {
    <mat-list-item [matMenuTriggerFor]="menuMonitoring">
        <!-- 'PRIV_VP_RTPN_VIEWER', -->
        <!-- hasMonitorRole || hasRtpnRole || hasAdminRole || hasReadOnlyRole -->
        <mat-icon>unfold_more</mat-icon>
        <a matline>Monitoring</a>
        <mat-icon>event</mat-icon>
    </mat-list-item>
    }
    <mat-menu #menuMonitoring="matMenu">
        @if (hasAllPrivileges(['PRIV_VP_JOB_MONITOR_VIEW','PRIV_VP_EVENT_OCCURANCE_VIEW'])) {
        <button mat-menu-item routerLink="/monitoring" (click)="onSidenavClose()">Events & Jobs<mat-icon>track_changes</mat-icon></button>
        }
        <!-- hasMonitorRole -->
<!--
        <button mat-menu-item routerLink="/rtpnTransactions" (click)="onSidenavClose()" *ngIf="hasPrivilege('PRIV_VP_RTPN_VIEWER')">RTPN Transactions<mat-icon>money</mat-icon></button>
 -->
        <!-- hasRtpnRole -->
        @if (hasPrivilege('PRIV_CM_HISTORY_VIEW')) {
        <button mat-menu-item routerLink="/communicationHistory" (click)="onSidenavClose()">Communication History<mat-icon>history</mat-icon></button>
        }
        <!-- hasMonitorRole -->
        @if (hasAnyPrivilege(['PRIV_VP_TEST_SUITE_VIEW','PRIV_VP_TEST_SUITE_ADD'])) {
        <button mat-menu-item routerLink="/testSuite" (click)="onSidenavClose()">Test Suite<mat-icon>event_available</mat-icon></button>
        }
        <!-- hasAdminRole -->
    </mat-menu>

    @if (hasAnyPrivilege(['PRIV_WA_USER_VIEW','PRIV_WA_USER_MODIFY','PRIV_CM_SUBSCRIPTION_VIEW','PRIV_CM_SUBSCRIPTION_MODIFY','PRIV_WAL_USERS_MODIFY'])) {
    <mat-list-item [matMenuTriggerFor]="menuAdministration">
        <!-- hasAdminRole || hasUserAdminRole -->
        <mat-icon>unfold_more</mat-icon>
        <a matline>User Administration</a>
        <mat-icon>assignment_ind</mat-icon>
    </mat-list-item>
    }
    <mat-menu #menuAdministration="matMenu">
        @if (hasAnyPrivilege(['PRIV_WA_ROLE_VIEW','PRIV_WA_ROLE_MODIFY'])) {
        <button mat-menu-item routerLink="/portalRoles" (click)="onSidenavClose()">Portal Roles<mat-icon>confirmation_number</mat-icon></button>
        }
        <!-- hasAdminRole -->
        @if (hasAnyPrivilege(['PRIV_WA_USER_MODIFY','PRIV_WA_USER_VIEW'])) {
        <button mat-menu-item routerLink="/portalUsers" (click)="onSidenavClose()">Portal Users<mat-icon>perm_identity</mat-icon></button>
        }
        <!-- hasAdminRole || hasUserAdminRole -->
      @if (hasPrivilege('PRIV_WA_USER_MODIFY')) {
      <button mat-menu-item routerLink="/groupOnboard" (click)="onSidenavClose()">Group Onboard<mat-icon>people_outline</mat-icon></button>
      }
      <!-- hasAdminRole -->
      @if (hasAnyPrivilege(['PRIV_CM_SUBSCRIPTION_VIEW','PRIV_CM_SUBSCRIPTION_MODIFY'])) {
      <button mat-menu-item routerLink="/communicationSubscribers" (click)="onSidenavClose()">Communication Subscribers<mat-icon>notifications</mat-icon></button>
      }
      <!-- hasAdminRole -->
      @if (hasAnyPrivilege(['PRIV_WAL_USERS_VIEW','PRIV_WAL_USERS_MODIFY'])) {
      <button mat-menu-item routerLink="/users" (click)="onSidenavClose()">Walletron Users<mat-icon>supervised_user_circle</mat-icon></button>
      }
      <!-- hasAdminRole -->
    </mat-menu>

    @if (hasAnyPrivilege(['PRIV_VP_BRAND_BOOTSTRAP','PRIV_WAL_BRAND_CONFIG_TEMPLATE_VIEW','PRIV_WAL_BRAND_CONFIG_TEMPLATE_MODIFY','PRIV_WAL_BRAND_CONFIG_ENROLL_LINKS', 'PRIV_WAL_ENROLLMENT_SIMULATOR'])) {
    <mat-list-item [matMenuTriggerFor]="menuBillerOnboarding">
        <!-- hasBrandBootstrapRole || hasBrandConfigRole || hasReadOnlyRole -->
        <mat-icon>unfold_more</mat-icon>
        <a matline>Brand Administration</a>
        <mat-icon>business_center</mat-icon>
    </mat-list-item>
    }
    <mat-menu #menuBillerOnboarding="matMenu">
        @if (hasPrivilege('PRIV_VP_BRAND_BOOTSTRAP')) {
        <button mat-menu-item routerLink="/brandBootstrap" (click)="onSidenavClose()">Brand Bootstrap<mat-icon>palette</mat-icon></button>
        }
        <!-- hasBrandBootstrapRole -->
        @if (hasAllPrivileges(['PRIV_WAL_BRAND_CONFIG_IMAGE_MODIFY','PRIV_WAL_BRAND_INFO'])) {
        <button mat-menu-item routerLink="/brandProfile" (click)="onSidenavClose()">Brand Profile<mat-icon>domain</mat-icon></button>
        }
        <!-- hasBrandConfigRole -->
        @if (hasAnyPrivilege(['PRIV_WAL_BRAND_CONFIG_PASS_VIEW','PRIV_WAL_BRAND_CONFIG_PASS_MODIFY'])) {
        <button mat-menu-item routerLink="/brandPassTemplates" (click)="onSidenavClose()">Pass Templates<mat-icon>table_chart</mat-icon></button>
        }
        <!-- hasBrandConfigRole -->
        @if (hasAnyPrivilege(['PRIV_WAL_BRAND_CONFIG_MSG_TEMPLATE_VIEW','PRIV_WAL_BRAND_CONFIG_MSG_TEMPLATE_MODIFY'])) {
        <button mat-menu-item routerLink="/messageTemplates" (click)="onSidenavClose()">Message Templates<mat-icon>tap_and_play</mat-icon></button>
        }
        <!-- hasBrandConfigRole -->
        @if (hasAnyPrivilege(['PRIV_WAL_BRAND_CONFIG_VARIABLE_MODIFY','PRIV_WAL_BRAND_CONFIG_VARIABLE_VIEW'])) {
        <button mat-menu-item routerLink="/brandVariables" (click)="onSidenavClose()">Brand Variables<mat-icon>developer_board</mat-icon></button>
        }
        <!-- hasBrandConfigRole -->
        @if (hasAnyPrivilege(['PRIV_WAL_BRAND_CONFIG_OFFER_MODIFY','PRIV_WAL_BRAND_CONFIG_OFFER_VIEW'])) {
        <button mat-menu-item routerLink="/brandOffers" (click)="onSidenavClose()">Brand Field Sets<mat-icon>format_list_numbered_rtl</mat-icon></button>
        }
        <!-- hasBrandConfigRole -->
        @if (hasAnyPrivilege(['PRIV_WAL_BRAND_CONFIG_PROP_MODIFY','PRIV_WAL_BRAND_CONFIG_PROP_VIEW'])) {
        <button mat-menu-item routerLink="/brandConfigProperty" (click)="onSidenavClose()">Brand Config Property<mat-icon>category</mat-icon></button>
        }
        <!-- hasBrandConfigRole -->
        @if (hasAnyPrivilege(['PRIV_WAL_BRAND_CONFIG_IMAGE_VIEW','PRIV_WAL_BRAND_CONFIG_IMAGE_MODIFY'])) {
        <button mat-menu-item routerLink="/brandImages" (click)="onSidenavClose()">Brand Images<mat-icon>camera_alt</mat-icon></button>
        }
        <!-- hasBrandConfigRole -->
        @if (hasAnyPrivilege(['PRIV_WAL_BRAND_CONFIG_TEMPLATE_VIEW','PRIV_WAL_BRAND_CONFIG_TEMPLATE_MODIFY'])) {
        <button mat-menu-item routerLink="/emailSmsTemplates" (click)="onSidenavClose()">Email/SMS Templates<mat-icon>email</mat-icon></button>
        }
        <!-- hasBrandConfigRole -->
        @if (hasAnyPrivilege(['PRIV_WAL_CONFIG_MAPPING_VIEW','PRIV_WAL_CONFIG_MAPPING_MODIFY'])) {
        <button mat-menu-item routerLink="/configMappings" (click)="onSidenavClose()">Config Mappings<mat-icon>view_comfy</mat-icon></button>
        }
        @if (hasAnyPrivilege(['PRIV_WAL_DAQ_CONFIG_VIEW','PRIV_WAL_DAQ_CONFIG'])) {
        <button mat-menu-item routerLink="/evEditor" (click)="onSidenavClose()">EV Config Editor<mat-icon>edit</mat-icon></button>
        }
        <!-- hasBrandConfigRole -->
        @if (hasPrivilege('PRIV_WAL_BRAND_CONFIG_ENROLL_LINKS')) {
        <button mat-menu-item routerLink="/enrollmentLinks" (click)="onSidenavClose()">Enrollment Links<mat-icon>link</mat-icon></button>
        }
        <!-- hasBrandConfigRole -->
        @if (hasPrivilege('PRIV_WAL_BRAND_CONFIG_ENROLL_LINKS')) {
        <button mat-menu-item routerLink="/qrcodeGeneration" (click)="onSidenavClose()">QR Codes<mat-icon>grain</mat-icon></button>
        }
        <!-- hasBrandConfigRole -->
        @if (hasAnyPrivilege(['PRIV_MS_EVENTS_VIEW','PRIV_MS_EVENTS_MODIFY'])) {
        <button mat-menu-item routerLink="/scheduledEvents" (click)="onSidenavClose()">Scheduled Events<mat-icon>access_alarms</mat-icon></button>
        }
        <!-- Enrollment Simulator && sharedSignalService.hasEnrollmentSimulator() -->
        @if (hasPrivilege('PRIV_WAL_ENROLLMENT_SIMULATOR')) {
        <button mat-menu-item routerLink="/enrollment-simulator" (click)="onSidenavClose()">Enrollment Simulator<mat-icon>filter_vintage</mat-icon></button>
        }
        @if (hasAnyPrivilege(['PRIV_WP_VIEWABLE_DOCUMENT_VIEW','PRIV_WP_VIEWABLE_DOCUMENT_MODIFY'])) {
        <button mat-menu-item routerLink="/view-docs" (click)="onSidenavClose()">Viewable Documents<mat-icon>picture_as_pdf</mat-icon></button>
        }
    </mat-menu>

    @if (hasAllPrivileges(['PRIV_WP_BRAND_VIEW','PRIV_WR_ADHOC_RPT']) || hasAnyPrivilege(['PRIV_WR_ADHOC_RPT','PRIV_CM_SUBSCRIPTION_MODIFY','PRIV_VP_BRAND_MIGRATE'])) {
    <mat-list-item [matMenuTriggerFor]="menuCustomizations">
        <!-- hasAdminRole || hasBrandListingRole -->
        <mat-icon>unfold_more</mat-icon>
        <a matline>Customizations</a>
        <mat-icon>build</mat-icon>
    </mat-list-item>
    }
    <mat-menu #menuCustomizations="matMenu">
        @if (hasAllPrivileges(['PRIV_WP_BRAND_VIEW','PRIV_WR_ADHOC_RPT'])) {
        <button mat-menu-item routerLink="/brandListing" (click)="onSidenavClose()">Brand Listing<mat-icon>card_membership</mat-icon></button>
        }
        <!-- hasAdminRole || hasBrandListingRole -->
        @if (hasPrivilege('PRIV_VP_BRAND_MIGRATE')) {
        <button mat-menu-item routerLink="/brandMigration" (click)="onSidenavClose()">Brand Migration<mat-icon>swap_horizontal_circle</mat-icon></button>
        }
        <!-- hasAdminRole -->
        @if (hasAnyPrivilege(['PRIV_WAL_BRAND_MASTER_CONFIG_PROP_MODIFY','PRIV_WAL_BRAND_MASTER_CONFIG_PROP_VIEW'])) {
        <button mat-menu-item routerLink="/configProperty" (click)="onSidenavClose()">Master Config Property<mat-icon>settings_applications</mat-icon></button>
        }
        <!-- <button mat-menu-item routerLink="/se-listing" (click)="onSidenavClose()">Scheduled Events Listing<mat-icon>view_list</mat-icon></button> -->
        <!-- hasAdminRole -->
        @if (hasPrivilege('PRIV_CM_SUBSCRIPTION_MODIFY')) {
        <button mat-menu-item routerLink="/messageProfile" (click)="onSidenavClose()">Message Profile<mat-icon>event_note</mat-icon></button>
        }
        <!-- hasAdminRole -->
        @if (hasPrivilege('PRIV_WP_ENCRYPTION')) {
        <button mat-menu-item routerLink="/encryptionUtility" (click)="onSidenavClose()">Encryption Utility<mat-icon>security</mat-icon></button>
        }
        <!-- hasAdminRole -->
    </mat-menu>

    @if (hasAnyPrivilege(['PRIV_WAL_ACCOUNT_INFO','PRIV_WAL_MESSAGE_TO_ACCOUNT','PRIV_WAL_ACCOUNT_MESSAGE','PRIV_WAL_DEATH_ROW_VIEW'])) {
    <mat-list-item [matMenuTriggerFor]="menuAccountAdministration">
        <!-- hasAcctAdminRole -->
        <mat-icon>unfold_more</mat-icon>
        <a matline>Account Administration</a>
        <mat-icon>cast_connected</mat-icon>
    </mat-list-item>
    }
    <mat-menu #menuAccountAdministration="matMenu">
        @if (hasPrivilege('PRIV_WAL_ACCOUNT_INFO')) {
        <button mat-menu-item routerLink="/accountInfo" (click)="onSidenavClose()">Account Info<mat-icon>location_city</mat-icon></button>
        }
        <!-- hasAcctAdminRole -->
        <!-- <button mat-menu-item routerLink="/adhoc-notification" (click)="onSidenavClose()" *ngIf="hasAnyPrivilege(['PRIV_WAL_FILTER_CONFIG_VIEW'])">Ad-hoc Notification<mat-icon>system_update</mat-icon></button> -->
        <!-- hasAcctAdminRole -->
        @if (hasPrivilege('PRIV_WAL_DEATH_ROW_VIEW')) {
        <button mat-menu-item routerLink="/acct-dereg-q" (click)="onSidenavClose()">Account Deregistration Queue<mat-icon>assignment_returned</mat-icon></button>
        }
    </mat-menu>


    @if (hasPrivilege('PRIV_VP_ACCT_CSR')) {
    <a mat-list-item routerLink="/csr-account" (click)="onSidenavClose()">
        <span class="nav-caption">CSR</span>   <mat-icon>headset_mic</mat-icon>
   </a>
   }

   @if (hasAnyPrivilege(['PRIV_WAL_MESSAGE_TO_ACCOUNT','PRIV_WAL_ACCOUNT_MESSAGE',
        'PRIV_WAL_FILTER_CONFIG_MODIFY','PRIV_WAL_ADHOC_MSG_TEMPLATE_MODIFY','PRIV_WAL_ADHOC_MSG_CONFIG','PRIV_WAL_MESSAGE_BATCH_EXEC_VIEW',
        'PRIV_WAL_ADHOC_MSG_EXECUTE'])) {
   <mat-list-item [matMenuTriggerFor]="menuCommunications">
        <mat-icon>unfold_more</mat-icon>
        <a matline>Communications</a>
        <mat-icon>present_to_all</mat-icon>
    </mat-list-item>
    }
    <mat-menu #menuCommunications="matMenu">
        @if (hasAnyPrivilege(['PRIV_WAL_MESSAGE_TO_ACCOUNT','PRIV_WAL_ACCOUNT_MESSAGE'])) {
        <button mat-menu-item routerLink="/messageBroadcasting" (click)="onSidenavClose()">Message Broadcasting<mat-icon>vibration</mat-icon></button>
        }
        @if (hasAllPrivileges(['PRIV_WAL_FILTER_CONFIG_MODIFY',
            'PRIV_WAL_ADHOC_MSG_TEMPLATE_MODIFY','PRIV_WAL_ADHOC_MSG_CONFIG','PRIV_WAL_MESSAGE_BATCH_EXEC_VIEW','PRIV_WAL_ADHOC_MSG_EXECUTE'])) {
        <button mat-menu-item routerLink="/adhoc-msg-config" (click)="onSidenavClose()">Targeted Communications<mat-icon>system_update</mat-icon></button>
        }
        @if (hasAnyPrivilege(['PRIV_WAL_MESSAGE_BATCH_EXEC_VIEW'])) {
        <button mat-menu-item routerLink="/msg-exec-viewer" (click)="onSidenavClose()">Message Executions<mat-icon>receipt</mat-icon></button>
        }
    </mat-menu>


    @if (hasPrivilege('PRIV_WR_STATS')) {
    <mat-list-item [matMenuTriggerFor]="menuStatistics">
        <!-- hasMonitorRole || hasStatsViewerRole -->
        <mat-icon>unfold_more</mat-icon>
        <a matline>Statistics</a>
        <mat-icon>developer_board</mat-icon>
    </mat-list-item>
    }
    <mat-menu #menuStatistics="matMenu">
<!-- 
        @if (hasPrivilege('PRIV_WR_STATS')) {
        <button mat-menu-item routerLink="/client-dashboard-tiles" (click)="onSidenavClose()">Client Dashboard<mat-icon>dashboard</mat-icon></button>
        }
-->
        <button mat-menu-item routerLink="/clientDashboard" (click)="onSidenavClose()" *ngIf="hasPrivilege('PRIV_WR_STATS')">Client Dashboard<mat-icon>dashboard</mat-icon></button>
        @if (hasPrivilege('PRIV_WR_STATS')) {
        <button mat-menu-item routerLink="/enrollmentStats" (click)="onSidenavClose()">Enrollment Clickthrough Stats<mat-icon>beenhere</mat-icon></button>
        }
        @if (hasPrivilege('PRIV_WR_STATS')) {
        <button mat-menu-item routerLink="/clickthroughStats" (click)="onSidenavClose()">Clickthroughs<mat-icon>nfc</mat-icon></button>
        }
        @if (hasPrivilege('PRIV_WR_STATS')) {
        <button mat-menu-item routerLink="/notificationStats" (click)="onSidenavClose()">Notifications<mat-icon>message</mat-icon></button>
        }
        @if (hasPrivilege('PRIV_VP_STATS')) {
        <button mat-menu-item routerLink="/enrollmentTrend" (click)="onSidenavClose()">Enrollment Trend<mat-icon>trending_up</mat-icon></button>
        } 
    </mat-menu>

    @if (hasAnyPrivilege(['PRIV_WR_RPT','PRIV_VP_STATS', 'PRIV_VP_ARTIFACT_VIEWER'])) {
    <mat-list-item [matMenuTriggerFor]="menuReports">
        <!-- hasMonitorRole -->
        <mat-icon>unfold_more</mat-icon>
        <a matline>Reports</a>
        <mat-icon>dvr</mat-icon>
    </mat-list-item>
    }
    <mat-menu #menuReports="matMenu">
        @if (hasPrivilege('PRIV_WR_RPT')) {
        <button mat-menu-item routerLink="/summaryReports" (click)="onSidenavClose()">Summary Reports<mat-icon>business</mat-icon></button>
        }
        @if (hasPrivilege('PRIV_WR_RPT')) {
        <button mat-menu-item routerLink="/apple-reenrollments" (click)="onSidenavClose()">Apple Re-enrollments<mat-icon>sync</mat-icon></button>
        }
        <!-- hasMonitorRole -->
        @if (hasPrivilege('PRIV_VP_ARTIFACT_VIEWER')) {
        <button mat-menu-item routerLink="/enrollmentReport" (click)="onSidenavClose()">Enrollment Report<mat-icon>group_add</mat-icon></button>
        }
        <!-- hasMonitorRole -->
        @if (hasPrivilege('PRIV_VP_ARTIFACT_VIEWER')) {
        <button mat-menu-item routerLink="/myArtifacts" (click)="onSidenavClose()">My Artifacts<mat-icon>folder</mat-icon></button>
        }

    </mat-menu>

    @if (hasAnyPrivilege(['PRIV_WAL_DEMO_SCENARIOS','PRIV_WAL_DEMO_DISTRIBUTION','PRIV_WAL_ACCOUNT_MESSAGE'])) {
    <mat-list-item [matMenuTriggerFor]="menuDemoSupport">
        <!-- hasDemoSupportRole -->
        <mat-icon>unfold_more</mat-icon>
        <a matline>Demo Support</a>
        <mat-icon>live_tv</mat-icon>
    </mat-list-item>
    }
    <mat-menu #menuDemoSupport="matMenu">
        @if (hasAllPrivileges(['PRIV_WAL_ACCOUNT_INFO','PRIV_WAL_MESSAGE_TO_ACCOUNT','PRIV_WAL_ACCOUNT_UPDATE','PRIV_WAL_ACCOUNT_MESSAGE','PRIV_WAL_DEMO_SCENARIOS'])) {
        <button mat-menu-item routerLink="/accountTasks" (click)="onSidenavClose()">Account Tasks<mat-icon>ballot</mat-icon></button>
        }
        <!-- hasDemoSupportRole -->
        @if (hasPrivilege('PRIV_WAL_DEMO_DISTRIBUTION')) {
        <button mat-menu-item routerLink="/enrollmentInvitation" (click)="onSidenavClose()">Enrollment Invitation<mat-icon>nfc</mat-icon></button>
        }
        <!-- <button mat-menu-item routerLink="/ai-chat" (click)="onSidenavClose()" *ngIf="hasPrivilege('PRIV_WAL_DEMO_SCENARIOS')">AI Chat<mat-icon>chat</mat-icon></button>
    -->
        <!-- hasDemoSupportRole -->
    </mat-menu>

    @if (hasAnyPrivilege(['PRIV_VP_RTPN_VIEWER','PRIV_RTPN_TEST'])) {
    <mat-list-item [matMenuTriggerFor]="menuRTPN">
        <mat-icon>unfold_more</mat-icon>
        <a matline>RTPN</a>
        <mat-icon>local_atm</mat-icon>
    </mat-list-item>
    }
    <mat-menu #menuRTPN="matMenu">
        @if (hasPrivilege('PRIV_VP_RTPN_VIEWER')) {
        <button mat-menu-item routerLink="/rtpn-transactions" (click)="onSidenavClose()">RTPN Transactions<mat-icon>money</mat-icon></button>
        }
        @if (hasPrivilege('PRIV_RTPN_TEST')) {
        <button mat-menu-item routerLink="/rtpn-simulator" (click)="onSidenavClose()">RTPN Simulator<mat-icon>developer_mode</mat-icon></button>
        }
    </mat-menu>

    @if (hasPrivilege('PRIV_PORTAL_USER_PROFILE')) {
    <a mat-list-item routerLink="/userProfile" (click)="onSidenavClose()">
        <span class="nav-caption">My Account</span>   <mat-icon>person</mat-icon>
   </a>
   }

</mat-nav-list>
}
